<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.diligence__assessment')}}</h4>
            <table class="mt-5 text-center table-bordered table-full-width" cellpadding="5" :key="EvaluationForm.totalScore">
              <tr>
                <th>{{$t('medium_grant_ev.diligence__assessment_total_score')}}</th>
                <th>{{$t('medium_grant_ev.diligence__assessment_risk_level')}}</th>
              </tr>
              <tr :class="{'selected-row': EvaluationForm.totalScore <= 25}">
                <td>{{$t('medium_grant_ev.diligence__assessment_25')}}</td>
                <td>{{$t('medium_grant_ev.diligence__assessment_low')}}</td>
              </tr>
              <tr :class="{'selected-row': EvaluationForm.totalScore > 25 && EvaluationForm.totalScore <= 40}">
                <td>{{$t('medium_grant_ev.diligence__assessment_26')}}</td>
                <td>{{$t('medium_grant_ev.diligence__assessment_medium')}}</td>
              </tr>
              <tr :class="{'selected-row': EvaluationForm.totalScore > 40}">
                <td>{{$t('medium_grant_ev.diligence__assessment_40')}}</td>
                <td>{{$t('medium_grant_ev.diligence__assessment_high')}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__comments_risks')}}</h5>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_specific_risks" :comments="EvaluationForm.model.comments_specific_risks"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-3">{{$t('medium_grant_ev.diligence__assessment_part2')}}</h5>
            <base-checkbox name="checkbox" v-model="EvaluationForm.model.part_two_i">
              {{$t('medium_grant_ev.diligence__assessment_part2_1')}}
            </base-checkbox>
            <base-checkbox name="checkbox" v-model="EvaluationForm.model.part_two_ii">
              {{$t('medium_grant_ev.diligence__assessment_part2_2')}}
            </base-checkbox>
            <base-checkbox name="checkbox" v-model="EvaluationForm.model.part_two_iii">
              {{$t('medium_grant_ev.diligence__assessment_part2_3')}}
            </base-checkbox>

            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_confirm_part_two" :comments="EvaluationForm.model.comments_confirm_part_two"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-3">{{$t('medium_grant_ev.diligence__assessment_part3')}}</h5>
            <radio name="model.overallconclussion"
                   value="1"
                   v-model="EvaluationForm.model.overall_conclussion"
            >
              {{$t('medium_grant_ev.diligence__assessment_part3_1')}}
            </radio>
            <radio name="model.overallconclussion" value="2" v-model="EvaluationForm.model.overall_conclussion">
              {{$t('medium_grant_ev.diligence__assessment_part3_2')}}
            </radio>
            <radio name="model.overallconclussion" value="3" v-model="EvaluationForm.model.overall_conclussion">
              {{$t('medium_grant_ev.diligence__assessment_part3_3')}}
            </radio>

            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_overall_conclussion" :comments="EvaluationForm.model.comments_overall_conclussion"></comment-box>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>